
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statePawn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"ancestorGroups.state.group.groupId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"int"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ancestorGroups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_dstrctbdgt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_steduaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_stmhaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_feddiscgrant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_fedformfund"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_fedideafund"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_fedblckgrant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_medicaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_privinsur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_selfpay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_privcmmntyfund"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_d4_otheragncy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_d4_other1_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_d4_other2_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_d4_other2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mental_health_profile_d4_other1"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1355}};
    doc.loc.source = {"body":"query($groupId: Int) {\n    roles(as: ANY) {\n        statePawn(\n            filter: { eq: { field: \"ancestorGroups.state.group.groupId\", int: $groupId } }\n            context: GLOBAL\n        ) {\n            ancestorGroups {\n                state {\n                    group {\n                        groupId\n                        label\n                    }\n                }\n            }\n            assignmentProgress {\n                devTags {\n                    mental_health_profile_dstrctbdgt\n                    mental_health_profile_steduaid\n                    mental_health_profile_stmhaid\n                    mental_health_profile_feddiscgrant\n                    mental_health_profile_fedformfund\n                    mental_health_profile_fedideafund\n                    mental_health_profile_fedblckgrant\n                    mental_health_profile_medicaid\n                    mental_health_profile_privinsur\n                    mental_health_profile_selfpay\n                    mental_health_profile_privcmmntyfund\n                    mental_health_profile_d4_otheragncy\n                    mental_health_profile_d4_other1_text\n                    mental_health_profile_d4_other2_text\n                    mental_health_profile_d4_other2\n                    mental_health_profile_d4_other1\n                }\n            }\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
